import type { RefValue } from "@common/types/auditLog";

/** Whether an audit diff side has nothing to show: no label, and a null, undefined or empty-string value. */
export const isEmptySnapshotValue = (ref: RefValue): boolean =>
    !ref.valueLabel &&
    (ref.value === null || ref.value === undefined || ref.value === "");
